/* eslint-disable no-console */

import {
  getAllCourses,
  getCurrentCourse,
  buyACourse,
  getCourseSyllabus
} from '../api/v1/course';
import {
  ADD_ALL_COURSES,
  BUY_COURSE_SUCCESSFUL,
  FETCH_COURSES_PROGRESS,
  GET_COURSE_SYLLABUS,
  UPDATE_CURRENT_COURSE_KEY,
  FETCH_ALL_COURSES,
  FETCH_CURRENT_COURSE
} from '../constants/actionTypes';

export const addAllCourses = value => ({
  type: ADD_ALL_COURSES,
  payload: value
});

export const fetchAllCoursesProgress = () => ({
  type: FETCH_COURSES_PROGRESS
});

export const addCurrentCourse = value => ({
  value
});

export const updateCourseKey = courseKey => dispatch => {
  dispatch({ type: UPDATE_CURRENT_COURSE_KEY, payload: { courseKey } });
};
export const fetchCourseSyllabus = ({
  name,
  email,
  phone,
  city,
  course_id
}) => (dispatch, start) => {
  start(GET_COURSE_SYLLABUS);
  return getCourseSyllabus(name, email, phone, city, course_id).then(res => {
    return res;
  });
};

export const fetchAllCourses = () => (dispatch, start) => {
  start(FETCH_ALL_COURSES);
  return getAllCourses().then(response => {
    return { value: response.data };
  });
};

export const fetchCurrentCourse = courseKey => (dispatch, start) => {
  start(FETCH_CURRENT_COURSE);
  return getCurrentCourse(courseKey).then(response => {
    if (response.errors) {
      return response;
    } else {
      return { value: response.data };
    }
  });
};

export const buyCourseSuccessful = value => ({
  type: BUY_COURSE_SUCCESSFUL,
  payload: value
});

export const buyCourse = (
  {
    courseKey,
    name,
    email,
    phone,
    dob,
    gender,
    city,
    hear_about_us,
    current_status,
    levelId,
    price
  },
  callback
) => dispatch =>
  buyACourse(
    courseKey,
    name,
    email,
    phone,
    dob,
    gender,
    city,
    hear_about_us,
    current_status,
    levelId,
    price
  )
    .then(response => {
      if (!response.errors) {
        dispatch(buyCourseSuccessful());

        if (callback) {
          callback({
            courseKey,
            name,
            email,
            phone,
            dob,
            gender,
            city,
            hear_about_us,
            current_status,
            levelId,
            price
          });
        }
      }
    })
    .catch(error => console.log(error));



// WEBPACK FOOTER //
// ./src/actions/course.js